export default __webpack_public_path__ + "static/media/moon.91396c73.jpg";